import { makeObservable, observable, runInAction } from 'mobx';
import { Addon, AddonList as AddonListModel, ChargeType } from '@data/models';
import Image from '@data/models/Image';
import MultilangText from '@data/models/MultilangText';
import TimeUtils from '@business/utils/time';
import { AddonsService } from '@data/api/services/addons';
import ReservationItem from '@data/models/ReservationItem';

export default class Addons {
  @observable model: AddonListModel | null = null;

  constructor() {
    makeObservable(this);
  }

  search = async (options: {
    propertyId: number;
    checkin: string;
    checkout: string;
    items: ReservationItem[];
  }) => {
    const { propertyId } = options;
    const checkin = options.checkin;
    const checkout = options.checkout;
    const items = options.items;

    runInAction(() => {
      this.model = null;
    });

    const result = !(propertyId && checkin && checkout)
      ? null
      : await AddonsService.search({
          propertyId,
          checkin,
          checkout,
          items,
        });

    runInAction(() => {
      this.model = result;
    });

    return result;
  };
}
